import SignInHelpContainer from "components/B/signInHelp/SignInHelpContainer";
import React from "react";

const SignInHelpRouter = () => {
    return (
        <>
            <SignInHelpContainer />
        </>
    );
};

export default SignInHelpRouter;
